import styled from 'styled-components';

import { SideNavRoute, Size } from '../../types';
import { handleSize } from './SideNav.helpers';
import colours from '../../../abstracts/colours';
import constants from '../../../abstracts/constants';

export interface SectionTitleProps {
  size?: Size;
  dataQaId?: string;
}

export const LinkStyleButton = styled.button`
  text-decoration: underline;
  font-size: ${(props: SideNavRoute) => (props.size ? handleSize(props.size) : constants.MEDIUM)};
  background-color: inherit;
  border: none;
  padding: 0;
  &:focus {
    background-color: ${colours.scienceBlue}0F;
  }
`;

export const SectionTitle = styled.h4<SectionTitleProps>`
  font-family: BlissPro;
  font-size: ${(props: SectionTitleProps) => (props.size ? handleSize(props.size) : constants.MEDIUM)};
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: ${colours.black};
`;

export const SideNavContainer = styled.aside`
  width: 360px;
  height: 100vh;
  display: flex;
  flex-direction: column;

  > * {
    &:not(:last-of-type) {
      margin-bottom: 16px;
    }
  }

  a,
  button {
    &:hover {
      cursor: pointer;
      color: ${colours.bluish};
    }
    &:active {
      color: ${colours.cobalt};
    }
  }
`;
